import DevicesSavePage from './Devices/tabs/digibes/DevicesSavePage';
import DeviceSavePage from './Devices/tabs/kitplay/tabs/DeviceSavePage';
import KitplayAreaSavePage from './Devices/tabs/kitplay/tabs/KitplayAreaSavePage';
import PrinterMappingListPage from './Devices/tabs/kitplay/tabs/PrinterMapping/PrinterMappingListPage';
import PrinterMappingSavePage from './Devices/tabs/kitplay/tabs/PrinterMapping/PrinterMappingSavePage';
import PickupDisplayDeviceSavePage from './Devices/tabs/pickupDisplay/PickupDisplayDeviceSavePage';
import PickupDisplayMappingListPage from './Devices/tabs/pickupDisplay/PickupDisplayMappingListPage';
import PiServerDeviceSavePage from './Devices/tabs/piServer/PiServerDeviceSavePage';
import DeviceTab from './Devices';
import RestaurantByCustomerListPage from './restaurant';
import TabletRequestListPage from './TabletRequest';
import ThirdPartyListPage from './ThirdParty';

export default {
    RestaurantByCustomerListPage: {
        path: '/shop-accounts/digibes-shop/:customerId/restaurants',
        title: 'Restaurant',
        auth: true,
        component: RestaurantByCustomerListPage,
    },
    deviceTabsRestaurantListPage: {
        path: '/shop-accounts/digibes-shop/:customerId/restaurants/device/tabs',
        auth: true,
        keyActiveTab: 'activeAccountDeviceTab',
        title: 'Device tabs',
        component: DeviceTab,
    },
    devicesRestaurantSavePage: {
        path: '/shop-accounts/digibes-shop/:customerId/restaurants/device/tabs/digibes/:id',
        title: 'Devices Save Page',
        auth: true,
        component: DevicesSavePage,
    },
    piServerDevicesRestaurantSavePage: {
        path: '/shop-accounts/digibes-shop/:customerId/restaurants/device/tabs/pi-server/:id',
        title: 'Pi server devices Save Page',
        auth: true,
        component: PiServerDeviceSavePage,
    },
    pickupDisplayDevicesRestaurantSavePage: {
        path: '/shop-accounts/digibes-shop/:customerId/restaurants/device/tabs/pickup-display/:id',
        title: 'ReadyBoard mappings Save Page',
        auth: true,
        component: PickupDisplayDeviceSavePage,
    },
    pickupDisplayMappingDevicesRestaurantListPage: {
        path: '/shop-accounts/digibes-shop/:customerId/restaurants/device/tabs/pickup-display/order-display-mapping',
        title: 'ReadyBoard mappings Save Page',
        auth: true,
        component: PickupDisplayMappingListPage,
    },
    printerMappingDevicesRestaurantListPage: {
        path: '/shop-accounts/digibes-shop/:customerId/restaurants/device/tabs/kitplay/printer-mapping',
        title: 'ReadyBoard mappings Save Page',
        auth: true,
        component: PrinterMappingListPage,
    },
    printerMappingDevicesRestaurantSavePage: {
        path: '/shop-accounts/digibes-shop/:customerId/restaurants/device/tabs/kitplay/printer-mapping/:id',
        title: 'ReadyBoard mappings Save Page',
        auth: true,
        component: PrinterMappingSavePage,
    },
    kitplayAreaDevicesRestaurantSavePage: {
        path: '/shop-accounts/digibes-shop/:customerId/restaurants/device/tabs/kitplay/area/:id',
        title: 'Kitplay area devices Save Page',
        auth: true,
        component: KitplayAreaSavePage,
    },
    kitplayGroupDeviceDevicesRestaurantSavePage: {
        path: '/shop-accounts/digibes-shop/:customerId/restaurants/device/tabs/kitplay/group-device/:id',
        title: 'Kitplay group device devices Save Page',
        auth: true,
        component: DeviceSavePage,
    },
    thirdPartyList: {
        path: '/shop-accounts/digibes-shop/:customerId/restaurants/third-party',
        title: 'Third party',
        auth: true,
        component: ThirdPartyListPage,
    },
    tabletRequestListPage: {
        path: '/shop-accounts/digibes-shop/:customerId/restaurants/tablet-request',
        title: 'Tablet request',
        auth: true,
        component: TabletRequestListPage,
    },
};
